import * as fieldModel from '../field';
import getFields from './get_fields';

/**
 * Get all active fields in the form
 */
export default function getActiveFields(element) {
  return [...getFields(element)].filter(fieldModel.isActive);
}



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/models/element/get_active_fields.js